import LinkButton from "ds/components/Button/LinkButton";
import Tooltip from "ds/components/Tooltip";

type ScheduleScanButtonProps = {
  disabled?: boolean;
  tooltipMessage?: string;
};

const ScheduleScanButton = ({ disabled, tooltipMessage }: ScheduleScanButtonProps) => (
  <Tooltip
    active={!!tooltipMessage}
    on={(props) => (
      <LinkButton {...props} variant="primary" disabled={!!disabled} to="/new/scan">
        Create scan
      </LinkButton>
    )}
  >
    {tooltipMessage}
  </Tooltip>
);

export default ScheduleScanButton;
